import { Grid, Typography } from "@mui/material";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
import 'moment/locale/de';
import { useEffect, useState } from 'react';
import DateRangeView from './DateRangeView';
import DateRangeOnlyView from './DateRangeOnlyView';
import StartDateOnlyView from './StartDateOnlyView';
import TimeOnlyView from './TimeOnlyView';
import { useTranslation } from "react-i18next";

const GoshClock = ({ type, endDateTime, timeOnlyMandatory, startValue, setStartValue, endValue, setEndValue, shouldUpdate, setUpdated }) => {

    const [startDate, setStartDate] = useState(moment());
    const [endDate, setEndDate] = useState(moment());

    const { t } = useTranslation();

    useEffect(() => {
        if (startValue !== undefined) {
            setStartDate(moment(startValue));
        };
        if (endValue !== undefined) {
            setEndDate(endValue);
        };
        // set enddate to nearest, current minutes exceeding, quarter
        if (startValue === undefined) {
            let mins = moment().minutes();
            let hrs = moment().hours();
            let updateStartTime = moment();
            let updateEndTime = moment();

            let h = mins > 45 ? (hrs === 23 ? 0 : ++hrs) : hrs;
            updateStartTime.set("hour", h);
            updateEndTime.set("hour", h);

            let quarters = [0, 15, 30, 45];

            let m = quarters.filter(q => q > mins);
            updateStartTime.set("minute", mins > 45 ? 0 : m[0]);
            updateEndTime.set("minute", mins > 45 ? 0 : m[0]);

            //have time be within 15 minute window
            updateStartTime.subtract(15, "minute");
            updateEndTime.subtract(15, "minute");

            setStartDate(updateStartTime);
            setStartValue(updateStartTime);

            updateEndTime.add(15, "minute");
            if (moment().hours() === 23 && moment().minutes() > 45) {
                updateEndTime.add(1, "hour");
            }
            setEndDate(updateEndTime);
            setEndValue(updateEndTime);
            // console.log(`${type}\n${endDateTime}\n${Math.trunc(moment(endValue).diff(moment(startValue), "day"))}`)
            // if ((type || endDateTime) && Math.trunc(moment(endValue).diff(moment(startValue), "day")) === 0) {
            //     const newEndDate = moment(endDate);
            //     newEndDate.add(1, "day");
            //     setEndDate(newEndDate);
            //     setEndValue(newEndDate);
            // }
        };
        //eslint-disable-next-line
    }, [startValue, endValue, type, endDateTime, timeOnlyMandatory])

    const getDuration = () => {
        const dayStartDate = moment(startDate).set("hour", 0).set("minute", 0).set("second", 0).set("millisecond", 0);
        const dayEndDate = moment(endDate).set("hour", 0).set("minute", 0).set("second", 0).set("millisecond", 0);
        const differenceAsDays = dayEndDate.diff(dayStartDate, "days");
        const differenceAsHours = moment(endDate).diff(moment(startDate), "hours");
        const differenceAsMinutes = moment(endDate).diff(moment(startDate), "minutes");

        if (!type && !endDateTime && !timeOnlyMandatory) {
            return t("indefinite")
        }
        if (differenceAsHours > 23 || type || endDateTime) {
            const hours = Math.trunc(differenceAsHours - (24 * differenceAsDays));
            const minutes = Math.trunc(differenceAsMinutes - (60 * differenceAsHours));
            if (Math.trunc(differenceAsDays) !== 0 && hours !== 0 && minutes !== 0 && !type) {
                return `${Math.trunc(differenceAsDays)} ${Math.trunc(differenceAsDays) === 1 ? t("day") : t("days")} & ${hours} ${hours === 1 ? t("hour") : t("hours")} & ${minutes} ${minutes === 1 ? t("minute") : t("minutes")}`;
            }
            if (Math.trunc(differenceAsDays) === 0 && hours !== 0 && minutes !== 0 && !type) {
                return `${hours} ${hours === 1 ? t("hour") : t("hours")} & ${minutes} ${minutes === 1 ? t("minute") : t("minutes")}`;
            }
            if (hours !== 0 && minutes === 0 && !type) {
                return `${Math.trunc(differenceAsDays)} ${Math.trunc(differenceAsDays) === 1 ? t("day") : t("days")} & ${hours} ${hours === 1 ? t("hour") : t("hours")}`;
            }
            if (hours === 0 && minutes !== 0 && !type) {
                return `${Math.trunc(differenceAsDays)} ${Math.trunc(differenceAsDays) === 1 ? t("day") : t("days")} & ${minutes} ${minutes === 1 ? t("minute") : t("minutes")}`;
            }
            return `${Math.trunc(differenceAsDays)} ${Math.trunc(differenceAsDays) === 1 ? t("day") : t("days")}`;
        } else if (differenceAsMinutes > 60) {
            const hours = Math.trunc(differenceAsHours);
            const minutes = Math.trunc(differenceAsMinutes - (60 * differenceAsHours));
            if (minutes === 0) {
                return `${hours} ${hours === 1 ? t("hour") : t("hours")}`;
            }
            return `${hours} ${hours === 1 ? t("hour") : t("hours")} ${t("and")} ${minutes} ${minutes === 1 ? t("minute") : t("minutes")}`;
        } else {
            const minutes = Math.trunc(differenceAsMinutes);
            return `${minutes} ${minutes === 1 ? t("minute") : t("minutes")}`;
        }
    };

    return (
        <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={localStorage.getItem("i18nextLng")}>
            <Grid container direction="column">
                {type ?
                    <DateRangeOnlyView startDate={startDate} setStartDate={setStartDate} setStartValue={setStartValue} endDate={endDate} setEndDate={setEndDate} setEndValue={setEndValue} shouldUpdate={shouldUpdate} setUpdated={setUpdated} /> :
                    endDateTime ?
                        <DateRangeView startDate={startDate} setStartDate={setStartDate} setStartValue={setStartValue} endDate={endDate} setEndDate={setEndDate} setEndValue={setEndValue} shouldUpdate={shouldUpdate} setUpdated={setUpdated} /> :
                        timeOnlyMandatory ?
                            <TimeOnlyView startDate={startDate} setStartDate={setStartDate} setStartValue={setStartValue} endDate={endDate} setEndDate={setEndDate} setEndValue={setEndValue} shouldUpdate={shouldUpdate} setUpdated={setUpdated} /> :
                            <StartDateOnlyView value={startDate} setValue={setStartDate} setStartValue={setStartValue} setEndDate={setEndDate} setEndValue={setEndValue} setUpdated={setUpdated} />
                }
                <Grid item justifyContent="center" sx={{ display: "flex" }}>
                    <Typography sx={{ color: "text.secondary" }}>{`${t("duration")}: ${getDuration()}`}</Typography>
                </Grid>
            </Grid>
        </LocalizationProvider>
    );

};

export default GoshClock;